export default __webpack_public_path__ + "static/media/icon_ask.e05271f2.svg";